/**
 * Wrapper around window.gtag (GA4). Safe no-op when gtag is not available
 * (e.g. blocked by adblocker, SSR, or before the script loads).
 */

const isAvailable = () =>
  typeof window !== 'undefined' && typeof window.gtag === 'function';

export const trackPageView = (path, title) => {
  if (!isAvailable()) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: title || document.title,
  });
};

export const trackEvent = (name, params = {}) => {
  if (!isAvailable()) return;
  window.gtag('event', name, params);
};
